import React/*, {useState}*/ from 'react';
import {Text} from 'react-native'
//import {Link} from 'react-router-dom';
import {useracc, getApi, postApi, putApi} from '../utils/functions';



//import Moment from 'react-moment';
import {UserContext} from '../utils/usercontext';

//import Accordion from 'react-bootstrap/Accordion';
//import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';

//const {hasCommandModifier} = KeyBindingUtil;
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';


//const Index = props => {
class NewShows extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			page: 0,
			log: {},
			logs: {
				log: ''
			},
			reason: '',
			edit: '',
			waiting: false,
    };
		this.handleChange = this.handleChange.bind(this);
    this.Delete = this.Delete.bind(this);
		this.Edit = this.Edit.bind(this);
		//this.NewShowAdd = this.NewShowAdd.bind(this);
		//this.NewShowDelete = this.NewShowDelete.bind(this);
		//this.NewShowConfirm = this.NewShowConfirm.bind(this);
  };

  //static contextType = UserContext;
  //loading:any = React.createRef();
  
  async componentDidMount() {
    //static contextType = AppContext;
    const value = this.context;

    //const [context, setContext] = useContext(UserContext);
    const getUser = await useracc();
    //console.log( getUser );
    //this.state.user = getUser;
    value.setUser( getUser );

    //console.log(this.context);

		var x = 0;
    if( this.props.match.params ) {
      if( this.props.match.params.id ) {
        x = parseInt( this.props.match.params.id );
      }
    }
		//console.log(x);
    //const [editorState, setEditorState] = useState('');
    const y = await getApi('/api/v1/details/'+x);
    //console.log( y.data.Log.log );

		//y.data.Log.log = y.data.Log.log.replace('boobies', 'https://blutopdfs.cc/torrents/34634');
		//this.setState({newshows: x.data.NewShows});
		this.setState({ page: x, logs: y.data.Log, edit: y.data.Log.description?y.data.Log.description:''});
  }

	handleChange(event) {
		var item = event.target.value;
    if( event.target.name === "reason" ) this.setState({reason: item});
		if( event.target.name === "edit" ) this.setState({edit: item});
	}

	Delete = async(e) => {
		this.setState({waiting: true});
    //this.NewShowConfirm(e, 1);
    const params = new URLSearchParams();
		params.append('id', this.state.page);
		params.append('reason', this.state.reason);
		//params.append('action', 'delete');

		try {
			let replace = document.getElementById(`replace`);
			if( replace.value ) params.append('replace', replace.value);
		} catch(error) {}

		await postApi('/api/v1/details', params);

		const y = await getApi('/api/v1/details/'+this.state.page);
    //console.log( y.data.Log );
		//this.setState({newshows: x.data.NewShows});
		this.setState({ logs: y.data.Log, waiting: false});
	}

	async Edit() {
		this.setState({waiting: true},async ()=>{

		
    	//this.NewShowConfirm(e, 1);

			//console.log(this.state.logs.site_id);

			const params = new URLSearchParams();
			params.append('id', this.state.logs.site_id);
			params.append('site', this.state.logs.site);
			params.append('edit', this.state.edit);
			//params.append('action', 'delete');
			//console.log(params);
			await putApi('/api/v1/details', params);

			const y = await getApi('/api/v1/details/'+this.state.page);
			//console.log( y.data.Log );
			//this.setState({newshows: x.data.NewShows});
			this.setState({ logs: y.data.Log, description: y.data.Log.description?y.data.Log.description:'', waiting: false});
		});
	}


  render() {
    
		const delimiter = /(?!.*deleted)(https:\/\/.*\/torrents\/\d{1,8})/g;

		const links = this.state.logs.log.split(delimiter).map((word, i) => {
			//console.log(word);
			const match = word.match(delimiter);
			if (match) {
				//console.log(match);
				const url = match[0];
				return (
					<a key={i} href={url.startsWith('http') ? url : `http://${url}`} target="_blank" rel="noreferrer">{url}</a>
				);
			}
			return word;
		})
		
    return (
      <>
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-12">
							{this.state.logs &&
								<Card border="success" >
									<Card.Header>
										{this.state.logs.name}<br />
										{this.state.logs.delete === true &&
											<>
												<Form.Control as="textarea" rows={3} name="reason" value={this.state.reason} onChange={e => this.handleChange(e)} className="mt-2" />
												{this.state.waiting===false &&
													<InputGroup size="sm" style={{maxWidth: 200}} className="pt-2">
														<Form.Control
															id='replace'
															placeholder="Replace ID"
															aria-label="Replace ID"
															aria-describedby="basic-addon1"
															className="mobile-width"
														/>
														<Button onClick={() => this.Delete()} variant="outline-danger" size="sm">Delete</Button>
													</InputGroup>
												}
											</>
										}
										{/*this.state.logs.edit === true &&
											<>
											<Form.Control as="textarea" className="mt-3" rows={6} name="edit" value={this.state.edit} onChange={e => this.handleChange(e)} />
												{this.state.waiting===false &&
													<>
														<Button onClick={() => this.Edit()} variant="outline-danger" size="sm">Edit description</Button>
													</>
												}
											</>
										*/}
									</Card.Header>
									<Card.Body>
										<Card.Title>{this.state.logs.command}</Card.Title>
										<Card.Text>
											<Text>{links}</Text>
										</Card.Text>
									</Card.Body>
								</Card>
							}
						</div>
					</div>
				</div>
    	</>
    );
  }
}

export default NewShows;
  